<template>
  <div>
    <vs-row v-if="visibleTitle" class="mb-4">
      <vs-col>
        <h5><i class="dot"></i>기본정보</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer">
      <slot name="after-custom-row" />
      <fragment v-for="type in inputList" :key="type">
        <div v-if="type === 'project_name'">
          <div class="title">분야명</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.project_name }}
            </div>
            <ml-input class="w-full" v-model="form.project_name" :readonly="board.readonly" />
          </div>
        </div>
        <div v-if="type === 'field_name'">
          <div class="title">{{ fieldLabel }}</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.field_name }}
            </div>
            <field-selector v-else class="w-full"
                            v-model="form.field_id"
                            :readonly="board.readonly"
                            :field-name="form.field_name"
                            @select="onSelectFieldSelector"
                            :field-label="fieldLabel"
                            :use-tab-codes="useTabCodes"/>
          </div>
        </div>
        <div v-if="type === 'department'">
          <div class="title">{{ inputLabel.department }}</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.department }}
            </div>
            <ml-input v-else class="w-full" v-model="form.department" readonly />
          </div>
        </div>
        <div v-if="type === '관리감독자직급'">
          <div class="title">{{ inputLabel.관리감독자직급 }}</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.관리감독자직급 }}
            </div>
            <ml-input v-else class="w-full" v-model="form.관리감독자직급" readonly />
          </div>
        </div>
        <div v-if="type === 'com_name'">
          <div class="title">{{ inputLabel.com_name }}</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.section }}
            </div>
            <ml-input v-else class="w-full" v-model="form.section" readonly />
          </div>
        </div>
        <div v-if="type === 'rank'">
          <div class="title">{{ inputLabel.rank }}</div>
          <div v-if="도급프로젝트">
            <div v-if="isPrint" class="print-input">관리감독자</div>
            <ml-input v-else class="w-full" value="관리감독자" readonly />
          </div>
          <div v-else>
            <div v-if="isPrint" class="print-input">
              {{ form.rank }}
            </div>
            <ml-input v-else class="w-full" v-model="form.rank" readonly />
          </div>
        </div>
        <div v-if="type === 'writer_name'">
          <div class="title">{{ inputLabel.writer_name }}</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.writer_name }}
            </div>
            <ml-input v-else class="w-full" v-model="form.writer_name" readonly />
          </div>
        </div>
        <div v-if="type === 'date'">
          <div class="title">{{ inputLabel.date }}</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.date }}
            </div>
            <date-selector v-else class="w-full" v-model="form.date" :readonly="board.readonly" />
          </div>
        </div>
        <!-- 수정일 추가 -->
        <div v-if="type === 'updated_at'">
          <div class="title">{{ inputLabel.updated_at }}</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.updated_at }}
            </div>
            <date-selector v-else class="w-full" :value="form.updated_at" readonly />
          </div>
        </div>
        <div v-if="type === 'custom_date'">
          <div class="title">{{ inputLabel.custom_date }}</div>
          <div>
            <div v-if="isPrint" class="print-input">
              {{ form.custom_date }}
            </div>
            <date-selector v-else class="w-full" v-model="form.custom_date" readonly />
          </div>
        </div>
      </fragment>

      <div v-for="option of options" :key="option.label" v-show="option.type !== 'alert'">
        <div class="title">{{ option.label }}</div>
        <div v-if="isPrint">
          <div class="print-input">
            {{ form[`${option.label}`] }}
          </div>
        </div>
        <div v-else class="overflow-visible">
          <date-selector v-if="option.type === 'date'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly || option.readonly" />
          <ml-input v-else-if="option.type === 'text'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly" />
          <disaster-class-selector v-else-if="option.type === 'disaster'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly" :multiple="option.multipleDisaster" />
          <sign-field v-else-if="option.type === 'sign'" :style="'justify-self: start;'" class="sign-module" v-model="form[`${option.label}`]" :readonly="board.readonly" />
          <time-selector v-else-if="option.type === 'time'" class="w-full flex-1" v-model="form[`${option.label}`]" :readonly="board.readonly" />
          <vs-select v-else-if="option.type === '요일'" class="w-full flex-1" autocomplete v-model="form[`${option.label}`]">
            <vs-select-item v-for="option in ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일']" :key="option" :text="option" :value="option" />
          </vs-select>
          <vs-select v-else-if="option.type === '날씨'" class="w-full flex-1" autocomplete v-model="form[`${option.label}`]">
            <vs-select-item v-for="option in ['맑음', '흐림', '눈', '비']" :key="option" :text="option" :value="option" />
          </vs-select>
        </div>
        <!-- <disaster-class-selector class="w-full" :readonly="board.readonly" :multiple="multipleDisaster" /> -->
      </div>
      <div v-if="!isPrint && (optionsType.includes('alert'))" class="xl:col-span-12">
        <div class="title">알림 대상자 선택</div>
        <AlertUserSelector class="w-full" v-model="form.notification" :readonly="board.readonly" />
      </div>
    </div>
  </div>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import SignField from "@/components/SignField.vue";
import AlertUserSelector from "@/components/selector/AlertUserSelector.vue";
import config from "/public/config";

export default {
  name: "FieldSelectModule",
  components: {
    DisasterClassSelector,
    TimeSelector,
    DateSelector,
    FieldSelector,
    SignField,
    AlertUserSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    fieldName: {
      type: String,
      default: "",
    },
    visibleTitle: {
      type: Boolean,
      default: () => true,
    },
    visibleFieldForm: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    date: {
      type: String,
      default: () => {
        return new Date().format("yyyy-MM-dd");
      },
    },
    types: {
      type: Array,
      default: () => {
        return [];
      },
    },
    typeslabel: {
      type: Object,
      default: () => {
        return {};
      },
    },
    useTabCodes: Array,
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    fieldLabel() {
      if (this.fieldName !== "") {
        return this.fieldName;
      }

      if (this.projectInfo.project_type === "총괄관리") {
        //ProjectId = 1
        return "사업장명";
      } else if (this.projectInfo.project_type === "내부종사자") {
        //ProjectId = 2
        return "작업장명";
      } else if (this.projectInfo.project_type === "도급") {
        //ProjectId = 3
        return "사업장명";
      } else if (this.projectInfo.project_type === "발주") {
        //ProjectId = 4
        return "사업장명";
      } else if (this.projectInfo.project_type === "중대시민재해") {
        //ProjectId = 5
        return "시설명";
      }
    },
    도급프로젝트() {
      return this.projectInfo.project_type === "도급";
    },
    inputList() {
      if (this.types && this.types.length > 0) {
        return this.types;
      } else if (this.도급프로젝트) {
        return ["field_name", "com_name", "date", "rank", "writer_name", "관리감독자직급"]
      } else {
        return ["field_name", "department", "com_name", "관리감독자직급", "writer_name", "date"]
      }
    },
    inputLabel() {
      return {
        title: this.typeslabel["title"] || "제목",
        field_name: this.typeslabel["field_name"] || "사업장명",
        department: this.typeslabel["department"] || (this.도급프로젝트 ? "직급" : "소속명"),
        com_name: this.typeslabel["com_name"] || "부서명",
        rank: this.typeslabel["rank"] || "직책",
        writer_name: this.typeslabel["writer_name"] || (this.도급프로젝트 ? "이름" : "작성자"),
        date: this.typeslabel["date"] || "작성일",
        custom_date: this.typeslabel["custom_date"] || "계약일",
        관리감독자직급: this.typeslabel["관리감독자직급"] || (this.도급프로젝트 ? "직급" : "직책"),
      }
    },
    optionsType() {
      return this.options.map((op) => op.type);
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        if (typeof this.value === "undefined" || typeof this.value.field_id === "undefined") {
          this.form.field_id = 0;
        } else {
          let 관리감독자직급 = '';
          if (this.value.관리감독자직급) {
            관리감독자직급 = this.value.관리감독자직급;
          } else if (this.board.writer.meta && this.board.writer.meta.관리감독자직급) {
            관리감독자직급 = this.board.writer.meta.관리감독자직급;
          }

          this.form.title = this.value.title;
          this.form.date = this.value.date;
          this.form.field_id = this.value.field_id;
          this.form.field_name = this.value.field_name;
          this.form.field_address = this.value.field_address;
          this.form.department = this.value.department;
          this.form.section = this.value.section;
          this.form.com_name = this.value.com_name;
          this.form.rank = this.value.rank;
          this.form.writer_name = this.value.writer_name;
          this.form.관리감독자직급 = 관리감독자직급;
          this.form.facility_category = this.value.facility_category;
          this.form.계획일 = this.value.계획일;
          this.form.검토일 = this.value.검토일;
          this.form.조사일 = this.value.조사일;
          this.form.점검일 = this.value.점검일;
          this.form.보수일 = this.value.보수일;
          this.form.진단일 = this.value.진단일;
          this.form.보강일 = this.value.보강일;
          this.form.교체일 = this.value.교체일;
          this.form.평가일 = this.value.평가일;
          this.form.점검장소 = this.value.점검장소;
          this.form.보수장소 = this.value.보수장소;
          this.form.재해형태 = this.value.재해형태;
          this.form.진단장소 = this.value.진단장소;
          this.form.보강장소 = this.value.보강장소;
          this.form.교체장소 = this.value.교체장소;
          this.form.평가자 = this.value.평가자;
          this.form.공정내용 = this.value.공정내용;

          this.form.총원 = this.value.총원;
          this.form.작업내용 = this.value.작업내용;
          this.form.점검시간 = this.value.점검시간;

          this.form.notification = this.value.notification;

          this.form.담당주무관 = this.value.담당주무관;
          this.form.사업시작기간 = this.value.사업시작기간;
          this.form.사업종료기간 = this.value.사업종료기간;
          this.form.meta = this.value.meta;

          // updated_at 추가
          const postId = this.$route.params.postId;
          const boardList = this.$store.state.board.list;
          for (const boardData of boardList) {
            if (boardData.id === postId) {
              this.form.updated_at = boardData.updated_at;
            }
          }
          this.form.custom_date = this.value.custom_date;
        }

        for (const option of this.options) {
          if (this.value) {
            this.form[`${option.label}`] = this.value[`${option.label}`] ? this.value[`${option.label}`] : "";
          } else {
            this.form[`${option.label}`] = "";
          }
        }
      },
    },
    form: {
      immediate: false,
      deep: true,
      handler() {
        this.$emit("input", this.form);
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler() {
        // post 를 불러왔을 경우에는
        // post 에 저장되어 있는 데이터를 사용하기 때문에,
        // board 의 정보로 데이터를 저장하지 않는다.
        if (!this.value || !this.value.com_name) {
          this.form.department = this.board.writer.department;
          this.form.section = this.board.writer.section;
          this.form.com_name = this.board.writer.com_name;
          this.form.rank = this.board.writer.rank;
          this.form.writer_name = this.board.writer.name;

          if (typeof this.value === "undefined" || typeof this.value.field_id === "undefined") {
            this.form.field_id = 0;
          } else {
            this.form.field_id = this.value.field_id;
            this.form.field_name = this.value.field_name;
            this.form.field_address = this.value.address;
          }

          for (const option of this.options) {
            if (this.value) {
              this.form[`${option.label}`] = this.value[`${option.label}`] ? this.value[`${option.label}`] : "";
            } else {
              this.form[`${option.label}`] = "";
            }
          }
        }
      },
    },
  },
  data() {
    return {
      hostname: config.HOST_NAME,
      form: {
        field_id: 0,
        title: "",
        field_name: "",
        field_address: "",
        department: "",
        section: "",
        com_name: "",
        rank: "",
        writer_name: "",
        관리감독자직급: "",
        facility_category: {
          id: '',
          cat1: '',
          cat2: '',
          cat3: '',
          cat4: ''
        },
        date: this.date,
        계획일: "",
        검토일: "",
        조사일: "",
        점검일: "",
        보수일: "",
        진단일: "",
        보강일: "",
        교체일: "",
        평가일: "",
        점검장소: "",
        보수장소: "",
        재해형태: "",
        진단장소: "",
        보강장소: "",
        교체장소: "",
        평가자: "",
        공정내용: "",

        총원: "",
        작업내용: "",
        점검시간: "",

        updated_at: "",
        custom_date: this.date,
        notification: [],

        meta: {},
        담당주무관: "",
        사업시작기간: "",
        사업종료기간: "",
      },
    };
  },

  created() {},

  methods: {
    onSelectFieldSelector(value) {
      this.form.field_name = value.field_name;
      this.form.field_address = value.address;
      if (value.facility_category) {
        this.form.facility_category = {
          id: value.facility_category.id,
          cat1: value.facility_category.cat1,
          cat2: value.facility_category.cat2,
          cat3: value.facility_category.cat3,
          cat4: value.facility_category.cat4,
        }
      } else {
        this.form.facility_category = {
          id: '',
          cat1: '',
          cat2: '',
          cat3: '',
          cat4: ''
        }
      }
      if (typeof value.meta === 'string') {
        this.form.meta = JSON.parse(value.meta);
      } else {
        this.form.meta = value.meta;
      }

      this.form.담당주무관 = value.manager_name
      this.form.사업시작기간 = value.work_begin_at
      this.form.사업종료기간 = value.work_end_at
      this.$emit("selectField", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.sign-module::v-deep {
  justify-content: normal !important;
  .sign-field {
    flex: 1;
    max-width: none;
  }
}
</style>
